import React from 'react';
import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '../../Session';
import { UserType } from '../../api';
import BasicLayout from '../../layouts/BasicLayout';
import UsersList from '../../pages/UsersList';

const UsersRoute = () => {
    const currentUser = useCurrentUser();

    if (currentUser.type !== UserType.Admin && currentUser.type !== UserType.SalesManager) {
        return <Redirect to="/403" />;
    }

    return (
        <BasicLayout>
            <UsersList />
        </BasicLayout>
    );
};

export default UsersRoute;
